//  Name: my-courses
import EventBus from '@/helpers/event-bus'

import '@/components/grid-courses'

export default {
  data () {
    return {

    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/my-courses/script.js